import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth, TeamAdmin, ContainerSecuritySettings } from '@byscott-io/corebyscott';

export default function AdminPage() {
  const { currentContainer } = useAuth();
  const [activeTab, setActiveTab] = useState('team');

  const tabs = [
    { id: 'team', label: 'Team' },
    { id: 'security', label: 'Security' },
  ];

  if (!currentContainer) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">No account selected.</p>
      </div>
    );
  }

  return (
    <div className="px-4 py-6 sm:px-0">
      <div className="mb-6">
        <Link to="/app" className="text-indigo-600 hover:text-indigo-800 text-sm">
          &larr; Back to Dashboard
        </Link>
        <h1 className="text-2xl font-semibold text-gray-900 mt-2">Admin Settings</h1>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-6 text-sm font-medium border-b-2 cursor-pointer ${
                  activeTab === tab.id
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {activeTab === 'team' && (
          <div className="p-6">
            <TeamAdmin />
          </div>
        )}

        {activeTab === 'security' && (
          <div className="p-6">
            <ContainerSecuritySettings />
          </div>
        )}
      </div>
    </div>
  );
}
